import React from 'react';
import PersonNameLabel, { PersonDataType } from '../person/PersonNameLabel';

interface ClientNameLabelProps {
  client: {
    personData: PersonDataType;
  };
  showDegrees?: boolean;
}

export default function ClientNameLabel({ client, showDegrees }: ClientNameLabelProps) {
  return <PersonNameLabel person={client} showDegrees={showDegrees} />;
}
